import styled from '@emotion/styled';

import { CompanyOnboardingContextProvider } from './CompanyOnboardingContext';
import { CompanySetupStep } from './CompanySetupStep';
import { OnboardingSidebar } from './OnboardingSidebar';

import type { FunctionComponent } from 'react';

const PageContainer = styled.div({
    backgroundColor: '#f6f6f7',
    display: 'grid',
    gridTemplateColumns: '16.5rem auto',
    gridTemplateRows: '1fr',
    height: '100vh',
});

const ContentArea = styled.div({
    backgroundColor: '#fbfbff',
    borderRadius: '1rem',
    margin: '1rem 1rem 1rem 0',
});

const RootContainer = styled.div({
    backgroundColor: '#fbfbff',
    borderRadius: '1rem',
    display: 'grid',
    gap: '2rem',
    gridTemplateRows: 'auto 1fr auto',
    height: '100%',
    padding: '6.96% 17.82% 14.53% 16.1%',
});

export const CompanyOnboardingSetupPage: FunctionComponent = () => {
    return (
        <CompanyOnboardingContextProvider>
            <PageContainer>
                <OnboardingSidebar />
                <ContentArea>
                    <RootContainer>
                        <CompanySetupStep />
                    </RootContainer>
                </ContentArea>
            </PageContainer>
        </CompanyOnboardingContextProvider>
    );
};
